import { combineReducers } from 'redux'
import { 
    GUEST_FETCH_ALL
  } from '../actions/constant'
const guestAll = (state = {isLoad:false, data:[]}, action) => {
    switch (action.type) {
        case GUEST_FETCH_ALL:
        return {isload:action.load, data:action.val}
        default:
        return state
    }
}

const guestReducer = combineReducers({
    guestAll
  })
  
  export default guestReducer